import {
  useQuery, UseQueryResult,
} from '@tanstack/react-query';
import { getNotesReport } from '../../services/Reports';

function useGetNotesReport(fleetId: string, query: string): UseQueryResult<any> {
  return useQuery(
    ['report-notes', fleetId, query],
    async (): Promise<any> => getNotesReport(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: false,
      refetchInterval: false,
    },
  );
}

export default useGetNotesReport;
